/**
 * Password Strength indiciator
 *  Used in account.module.js
 *    for create account
 *    for forgot password
 */
define([], function() {
  let PasswordStrength = {
    init: function() {
      if (!$('#logonPassword').length > 0 || $('#RegisterForm, #ChangePasswordForm, #RegisterFormBD').length == 0) return;
      $('#logonPassword:not(.nostrength)').keyup(this.passwordStrength).focusin(function() {
        $('#PasswordStrength').show();
      })
      $('#logonPasswordVerify').keyup(this.passwordMatch).focusin(function() {
        $('#PasswordStrength').show();
      })
    },
    passwordStrength: function() {
      let value = $(this).val();
      let entropy = ['short', 'weak', 'fair', 'good', 'strong'];
      let degree = 0;
      if (/.{8,20}/.test(value)) {
        degree++;
        $('.chars').removeClass('invalid').addClass('valid');
        if (/.{10,20}/.test(value)) {
          if (/(?=.*[a-z])/.test(value)) {
            degree++;
          }
          if (/(?=.*[A-Z])/.test(value)) {
            degree++;
          }
          if (/(?=.*\d)/.test(value)) {
            degree++;
          }
          if (/[!,%,&,@,#,$,^,*,?,_,~]/.test(value)) {
            degree++;
          }
          degree--;
        }
      } else {
        $('.chars').removeClass('valid').addClass('invalid');
      }
      if (/[a-z,A-Z]/.test(value)) {
        $('.letters').removeClass('invalid').addClass('valid');
      } else {
        $('.letters').removeClass('valid').addClass('invalid');
      }
      if (/[<,>,",\\,\s,\.]/.test(value)) {
        $('.special').removeClass('valid').addClass('invalid');
      } else {
        $('.special').removeClass('invalid').addClass('valid');
      }
      $('#PasswordStrength').removeClass().addClass(entropy[degree]);
      if ($('#logonPasswordVerify').val().length > 0) {
        PasswordStrength.passwordMatch();
      } else if ($('#logonPassword').val().length == 0 && $('#logonPasswordVerify').val().length == 0) {
        $('.valid').removeClass('valid');
        $('.invalid').removeClass('invalid');
      }
    },
    passwordMatch: function() {
      if ($('#logonPasswordVerify').val().length > 0) {
        if ($('#logonPasswordVerify').val() == $('#logonPassword').val()) {
          $('.match').removeClass('invalid').addClass('valid');
        } else {
          $('.match').removeClass('valid').addClass('invalid');
        }
      }
      if ($('#logonPassword').val().length == 0 && $('#logonPasswordVerify').val().length == 0) {
        $('.valid').removeClass('valid');
        $('.invalid').removeClass('invalid');
      }
    },
  };
  if (typeof window.COSTCO == 'undefined') {
    window.COSTCO = {};
  }
  window.COSTCO.PasswordStrength = PasswordStrength;
  return PasswordStrength;
});



// WEBPACK FOOTER //
// ./js/account/password-strength.js